import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5),
};

export const illustration: SxStyle = {
  width: '100%',
  height: 'auto',
  aspectRatio: '456 / 255',
  objectFit: 'cover',
  display: 'block',
  borderRadius: (p) => p.spacing(0.5),
};

export const message: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.75),
};

export const footer: SxStyle = {
  justifyContent: 'flex-end',
  padding: (p) => p.spacing(1.5),
};
